import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import CtaButton from './cta-button'
import { t } from '../../core/i18n'

// TODO
const saveItemFunction = id => () => {}

const SaveCtaButton = props => {
  const { id, isSaved } = props
  return (
    <CtaButton
      className={classNames({
        'cta-button-terciary': !isSaved
      })}
      onClick={saveItemFunction(id)}
      text={isSaved ? t('common:saved') : t('common:save')}
      isActive={isSaved}
      iconName={isSaved ? 'saved' : 'save'}
    />
  )
}

SaveCtaButton.defaultProps = {
  id: 1,
  isSaved: false
}

SaveCtaButton.propTypes = {
  id: PropTypes.number.isRequired,
  isSaved: PropTypes.bool.isRequired
}

export default SaveCtaButton



// WEBPACK FOOTER //
// ./src/ui/buttons/SaveCtaButton.js